import React from 'react';
import { ShieldCheck, BadgeCheck, FileText, Award } from 'lucide-react';
import { TRUST } from '../data/site';
import { TESTIDS } from '../constants/testIds';

const ICONS = [ShieldCheck, BadgeCheck, FileText];

export const Trust = () => {
  return (
    <section data-testid={TESTIDS.trustSection} className="relative bg-[#E8B842] text-black">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 sm:py-20">
        <div className="grid lg:grid-cols-12 gap-10 items-center">
          <div className="lg:col-span-4 flex items-center gap-6">
            <div className="relative shrink-0">
              <div className="w-24 h-24 rounded-full bg-black text-[#E8B842] flex items-center justify-center border-4 border-black">
                <Award className="w-12 h-12" />
              </div>
              <div className="absolute inset-0 rounded-full border-2 border-dashed border-black/40 animate-[spin_20s_linear_infinite]" />
            </div>
            <div>
              <div className="font-display uppercase tracking-[0.3em] text-xs">Promise</div>
              <div className="font-display uppercase font-extrabold text-3xl sm:text-4xl leading-none mt-1">
                Guaranteed<br />Work
              </div>
            </div>
          </div>

          <div className="lg:col-span-8 grid sm:grid-cols-3 gap-6">
            {TRUST.map((t, i) => {
              const Icon = ICONS[i];
              return (
                <div
                  key={t.title}
                  className="border-l-2 border-black/40 pl-5"
                >
                  <Icon className="w-8 h-8 mb-3" />
                  <div className="font-display uppercase font-bold text-xl leading-tight">
                    {t.title}
                  </div>
                  <p className="text-sm mt-2 text-black/80 leading-relaxed">{t.detail}</p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Trust;
